module.exports = __webpack_public_path__ + "static/media/adicionais.a4bfe52e.png";